module.exports = __webpack_public_path__ + "static/media/L.235158b1.jpg";